// @flow
/**
 * User: Mike Chung
 * Date: 4/3/2018
 * Time: 6:04 PM
 */

export default {
    "apiGatewayHostname": "api-ebbe.hktdc.com",
    "apiGatewayProcotol": "https",
    "apiGatewayContext": "",

    "apiKey": "8MPXc21H5R7QkqD8D18um2aVaE2ZgxR959WYDBQz",

    "countryListAPI": "https://api-general.hktdc.com/field-option/v1/countries?language=en",

    "unlockCountDialogThreshold": 0,

    "superUserRole": "ebbe-admin",

    "roleConfigs": {
        "default": {
            "idleTimeout": 5000,
            "allowToLinkEBadge": false,
            "allowPhotoEBadgeManagement": false,
            "allowToDelete": false,
            "allowToVerify": false,
            "allowGenerateQrCode": false,
        },
        "ebbe-user": {
            "idleTimeout": 90000,
            "allowToLinkEBadge": false,
            "allowPhotoEBadgeManagement": true,
            "allowToDelete": false,
            "allowToVerify": false,
            "allowGenerateQrCode": false,
        },
        "ebbe-admin": {
            "idleTimeout": 300000,
            "allowToLinkEBadge": true,
            "allowPhotoEBadgeManagement": true,
            "allowToDelete": true,
            "allowToVerify": true,
            "allowGenerateQrCode": true,
        }
    },

    "enableResetButton": true,

    "isAbleToHighlightYearForRegCode": true,

    "enableTheLinkInEmailField": true
}



// WEBPACK FOOTER //
// ./src/config/config.js